import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import config from '../../config';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  MenuItem,
} from '@mui/material';
import { Divider } from '@mui/material';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  TextField,
  Box,
  CircularProgress,
} from '@mui/material';
const company = JSON.parse(sessionStorage.getItem('companyDetails'));
export default function HotelList() {
  const [hotels, setHotels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [searchText, setSearchText] = useState('');
  const rowsPerPage = 5;
  const url = `${config.API_BASE_URL}${config.PRODUCT_LIST_API}`;
  const [open, setOpen] = useState(false);
  const [editHotel, setEditHotel] = useState(null);
  useEffect(() => {
    fetchHotels();
  }, []);
  const fetchHotels = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) return;

    try {
      const response = await fetch(
        `${config.API_BASE_URL}/Home/GetHotels/${encodeURIComponent(company?.id)}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (!response.ok) {
        console.error('Failed to fetch hotels:', response.statusText);
        setLoading(false);
        return;
      }

      const data = await response.json();
      console.log(data);
      setHotels(data);
    } catch (error) {
      console.error('Error fetching hotels:', error);
    }
    setLoading(false);
  };
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    setPage(0);
  };

  const handleEditClick = (hotel) => {
    setEditHotel({
      hotelId: hotel.id,
      hotelName: hotel.hotelName,
      address: hotel.address,
      mobile: hotel.mobile,
      state: hotel.state,
      city: hotel.city,
      email: hotel.email,
      checkInTime: hotel.checkInTime,
      checkOutTime: hotel.checkOutTime,
      termsAndCondition: hotel.termsAndCondition || '',
      instagramLink: hotel.instagramLink || '',
      websiteLink: hotel.websiteLink || '',
      facebookLink: hotel.facebookLink || '',
      gstNumber: hotel.gstNumber || '',
      foodLicenseNumber: hotel.foodLicenseNumber || '',
      bankname: hotel.bankName || '',
      ifsccode: hotel.ifsc || '',
      accountno: hotel.bankAccountNumber || '',
      bankaddress: hotel.bankAddress || '',
    });
    setOpen(true);
  };
  const handleUpdateHotel = async () => {
    const token = sessionStorage.getItem('token');

    try {
      const res = await fetch(`${config.API_BASE_URL}/Home/UpdateHotel`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editHotel),
      });

      if (!res.ok) {
        toast.error('Update failed');
        return;
      }

      setOpen(false);
      fetchHotels(); // refresh list
    } catch (err) {
      console.error(err);
    }
  };

  // Search by multiple fields dynamically
  const filteredHotels = hotels.filter((hotel) =>
    Object.keys(hotel)
      .filter((key) => key !== 'Id') // exclude Id if you want
      .some((key) =>
        hotel[key]?.toString().toLowerCase().includes(searchText.toLowerCase()),
      ),
  );

  if (loading) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        minHeight='50vh'>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Typography variant='h4' fontWeight='bold' mb={3}>
        Hotels List
      </Typography>

      <Box mb={2} maxWidth={300}>
        <TextField
          fullWidth
          label='Search'
          variant='outlined'
          value={searchText}
          onChange={handleSearchChange}
          size='small'
          inputProps={{ 'aria-label': 'search hotels' }}
        />
      </Box>

      <Paper
        sx={{
          borderRadius: 4,
          overflow: 'hidden',
          boxShadow: '0 10px 15px rgb(0 0 0 / 0.1)',
        }}>
        <TableContainer sx={{ maxHeight: 500 }}>
          <Table stickyHeader aria-label='hotels table'>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#4a90e2' }}>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  Hotel Name
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  Floor
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  Rating
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  Address
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  City
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  City Code
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  State
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  Mobile
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  Email
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  Created
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  Check in Time
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  Check Out Time
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  Floor
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  FoodLicenseNumber
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  GstNumber
                </TableCell>
                <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>
                  Active Status
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredHotels.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={13} align='center' sx={{ py: 4 }}>
                    No hotels found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredHotels
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((hotel, i) => (
                    <TableRow
                      key={hotel.id}
                      hover
                      sx={{
                        backgroundColor: i % 2 ? '#f7f9fc' : 'white',
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: '#d1eaff',
                          boxShadow: '0 5px 10px rgba(74,144,226,0.3)',
                          transition: 'all 0.3s ease',
                        },
                      }}
                      tabIndex={0}
                      role='row'>
                      <TableCell>{hotel.hotelName}</TableCell>
                      <TableCell>{hotel.flor}</TableCell>
                      <TableCell>{hotel.rating}</TableCell>
                      <TableCell>{hotel.address}</TableCell>
                      <TableCell>{hotel.city}</TableCell>
                      <TableCell>{hotel.citycode}</TableCell>
                      <TableCell>{hotel.state}</TableCell>
                      <TableCell>{hotel.mobile}</TableCell>
                      <TableCell>{hotel.email}</TableCell>
                      <TableCell>
                        {new Date(hotel.created).toLocaleDateString('en-GB')}
                      </TableCell>
                      <TableCell>{hotel.checkInTime}</TableCell>
                      <TableCell>{hotel.checkOutTime}</TableCell>
                      <TableCell>{hotel.flor}</TableCell>
                      <TableCell>{hotel.foodLicenseNumber}</TableCell>
                      <TableCell>{hotel.gstNumber}</TableCell>
                      <TableCell>
                        {hotel.activeStatus ? 'Active' : 'Inactive'}
                      </TableCell>
                      <TableCell>
                        <Button
                          size='small'
                          variant='contained'
                          onClick={() => handleEditClick(hotel)}>
                          Update
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5]}
          component='div'
          count={filteredHotels.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          labelRowsPerPage=''
          sx={{ bgcolor: '#f0f3f7' }}
        />
      </Paper>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth='md'
        fullWidth
        scroll='paper'>
        <DialogTitle sx={{ fontWeight: 600 }}>Update Hotel Details</DialogTitle>

        <DialogContent
          sx={{
            bgcolor: '#f9fafb',
            maxHeight: '75vh',
          }}>
          <Grid container spacing={3}>
            {/* ===== BASIC INFORMATION ===== */}
            <Grid item xs={12}>
              <Paper
                variant='outlined'
                sx={{
                  p: 3,
                  width: '100%',
                }}>
                <Typography fontWeight={600} mb={2}>
                  Basic Information
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='Hotel Name'
                      value={editHotel?.hotelName || ''}
                      onChange={(e) =>
                        setEditHotel({
                          ...editHotel,
                          hotelName: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='Mobile'
                      value={editHotel?.mobile || ''}
                      onChange={(e) =>
                        setEditHotel({ ...editHotel, mobile: e.target.value })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='Email'
                      type='email'
                      value={editHotel?.email || ''}
                      onChange={(e) =>
                        setEditHotel({ ...editHotel, email: e.target.value })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='Address'
                      value={editHotel?.address || ''}
                      onChange={(e) =>
                        setEditHotel({ ...editHotel, address: e.target.value })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='City'
                      value={editHotel?.city || ''}
                      onChange={(e) =>
                        setEditHotel({ ...editHotel, city: e.target.value })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='State'
                      value={editHotel?.state || ''}
                      onChange={(e) =>
                        setEditHotel({ ...editHotel, state: e.target.value })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='GstNumber'
                      value={editHotel?.gstNumber || ''}
                      onChange={(e) =>
                        setEditHotel({
                          ...editHotel,
                          gstNumber: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='FoodLicenseNumber'
                      value={editHotel?.foodLicenseNumber || ''}
                      onChange={(e) =>
                        setEditHotel({
                          ...editHotel,
                          foodLicenseNumber: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='Bank Name'
                      value={editHotel?.bankname || ''}
                      onChange={(e) =>
                        setEditHotel({
                          ...editHotel,
                          bankname: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='IFSC Code'
                      value={editHotel?.ifsccode || ''}
                      onChange={(e) =>
                        setEditHotel({
                          ...editHotel,
                          ifsccode: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='Accoount Number'
                      value={editHotel?.accountno || ''}
                      onChange={(e) =>
                        setEditHotel({
                          ...editHotel,
                          accountno: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='Bank Address'
                      value={editHotel?.bankaddress || ''}
                      onChange={(e) =>
                        setEditHotel({
                          ...editHotel,
                          bankaddress: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      type='time'
                      label='Check-in'
                      InputLabelProps={{ shrink: true }}
                      value={editHotel?.checkInTime || ''}
                      onChange={(e) =>
                        setEditHotel({
                          ...editHotel,
                          checkInTime: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      type='time'
                      label='Check-out'
                      InputLabelProps={{ shrink: true }}
                      value={editHotel?.checkOutTime || ''}
                      onChange={(e) =>
                        setEditHotel({
                          ...editHotel,
                          checkOutTime: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* ===== TERMS & CONDITIONS (100% FULL WIDTH – FIXED) ===== */}
            <Box sx={{ width: '100%', mt: 3 }}>
              <Paper
                variant='outlined'
                sx={{
                  p: 3,
                  width: '100%',
                  boxSizing: 'border-box',
                }}>
                <Typography fontWeight={600} mb={2}>
                  Terms & Conditions
                </Typography>

                <TextField
                  fullWidth
                  multiline
                  rows={5}
                  placeholder='Enter hotel terms & conditions...'
                  value={editHotel?.termsAndCondition || ''}
                  onChange={(e) =>
                    setEditHotel({
                      ...editHotel,
                      termsAndCondition: e.target.value,
                    })
                  }
                />
              </Paper>
            </Box>

            {/* ===== SOCIAL MEDIA LINKS ===== */}
            <Grid item xs={12}>
              <Paper
                variant='outlined'
                sx={{
                  p: 3,
                  width: '100%',
                }}>
                <Typography fontWeight={600} mb={2}>
                  Social Media Links
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='Website URL'
                      value={editHotel?.websiteLink || ''}
                      onChange={(e) =>
                        setEditHotel({
                          ...editHotel,
                          websiteLink: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='Facebook URL'
                      value={editHotel?.facebookLink || ''}
                      onChange={(e) =>
                        setEditHotel({
                          ...editHotel,
                          facebookLink: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label='Instagram URL'
                      value={editHotel?.instagramLink || ''}
                      onChange={(e) =>
                        setEditHotel({
                          ...editHotel,
                          instagramLink: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={() => setOpen(false)} color='inherit'>
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={handleUpdateHotel}>
            Update Hotel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
